import Msgcomponent from "./Msg.vue"
const Msg ={}
Msg.install = (Vue)=>{
    const vue = Vue
    const MsgClass = vue.extend(Msgcomponent)
    const instance = new MsgClass() 
    instance .$mount(document.createElement("div"))
    document.body.appendChild(instance.$el)
    let timer
    const MsgMain = {
        show_message(msg,type){
            clearTimeout(timer)
            timer = setTimeout(() => {
                instance.visbile =false
            }, 3000);
            instance.msg = msg
            instance.type=type
            instance.visbile = true
        },
        success(msg,type="success"){
            this.show_message(msg,type)
        },
        fail(msg,type="fail"){
            this.show_message(msg,type)
        },
        warning(msg,type="warning"){
            this.show_message(msg,type)
        }
    }
    vue.prototype.$message = MsgMain
}
export default Msg


// WEBPACK FOOTER //
// ./src/components/Msg/Msg.js